import React from "react";
import styled from "styled-components";
import { pxToEm } from "../../util/helpers";
import constants from "../_globalStyles/constants";
import { PageComponentProps } from "../../interfaces/common";
import Button from "../atoms/Button";

type EmojiSize = "small" | "normal";

interface InfoBoxProps extends PageComponentProps {
  emoji: string;
  text: string;
  emojiSize?: EmojiSize;
  buttonText?: string;
  onClick?: () => void;
}

const InfoBox: React.FunctionComponent<InfoBoxProps> = ({
  emoji,
  text,
  className,
  idPrefix,
  buttonText,
  onClick,
  emojiSize = "normal"
}) => {
  const InfoBoxView = styled.div`
    padding: 1rem;
    border: 1px solid ${constants.INPUT_ACTIVE};
    border-radius: ${pxToEm(24, 16)}rem;
    max-width: 25em;
    margin: auto;

    .text-wrap {
      align-items: center;
      display: flex;
    }

    .emoji {
      font-size: ${emojiSize === "small" ? pxToEm(20, 16) : pxToEm(32, 16)}rem;
      margin-right: 1rem;
    }

    .text {
      font-weight: bold;
      color: ${constants.INPUT_ACTIVE};
      line-height: ${pxToEm(19, 16)}rem;
      margin: 0;
    }

    button {
      margin-top: ${pxToEm(14, 16)}rem;
    }
  `;

  return (
    <InfoBoxView data-testid={idPrefix} className={className ? className : ""}>
      <div className="text-wrap">
        <span className="emoji">{emoji}</span>
        <p className="text cfl">{text}</p>
      </div>
      {buttonText && (
        <Button fullWidth small onClick={onClick}>
          {buttonText}
        </Button>
      )}
    </InfoBoxView>
  );
};

export default InfoBox;
